export function selectIsAdmin(state) {
  const user = state.user.user
  return user?.data?.mobile && user.data.mobile.startsWith('+852999098')
}
